export default __webpack_public_path__ + "static/ana_l-61580e009f113e3b3b6a0f96c00b6f29.png";